import { humanize, moment } from 'utils';

import BasePropertyObject from './BasePropertyObject';

export default class BaseRealEstateObject extends BasePropertyObject {
  constructor({
    address,
    area,
    areaMeasure,
    cadastreDate,
    cadastralNumber,
    costHistory,
    codeSkz31,
    ...abstractPropertyObjectConfig
  }) {
    super(abstractPropertyObjectConfig);

    Object.assign(this, {
      address,
      area,
      areaMeasure,
      cadastralNumber,
      costHistory,
      cadastreDate: cadastreDate && moment.fromServerDatetime(cadastreDate),
      codeSkz31,
    });

    Object.assign(this.propertyTitles, {
      address: 'Адрес',
      area: 'Площадь (кв.м.)',
      cadastreDate: 'Дата кадастрового учёта',
      cadastralNumber: 'Кадастровый номер',
      costHistory: 'Стоимость объекта недвижимости',
      codeSkz31: 'Разрешенное использование',
    });

    Object.assign(this.propertyDisplayValueGetters, {
      area: () => (this.area ? humanize(this.area) : this.area),
      cadastreDate: () => {
        return this.cadastreDate && this.cadastreDate.defaultFormat();
      },
      codeSkz31: () => this.getCodeSkz31(),
    });
  }

  static typeTitle = 'Недвижимое имущество';

  getTypeTitle() {
    return BaseRealEstateObject.typeTitle;
  }

  getTitle() {
    return super.getTitle() || this.address;
  }

  getName() {
    return this.address;
  }

  getCategoryTitle() {
    return this.title || this.sntsType || '';
  }

  getPdfTitle() {
    return `${super.getPdfTitle()}, ${this.address} `;
  }

  isRealEstate() {
    return true;
  }

  getCostHistory() {
    return this.getPropertyInfo('costHistory');
  }

  getDataProvider() {
    return {
      title: this.propertyTitles.dataProvider,
      urlTitle: 'Росреестром',
      url: 'https://rosreestr.ru/site/',
    };
  }

  getCodeSkz31() {
    return (this.codeSkz31 || '').toLowerCase();
  }
}
